"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentType = void 0;
exports.DocumentType = {
    Invoice: "INVOICE",
    TenNinetyNine: "TEN_NINETY_NINE",
    W9: "W9",
    Check: "CHECK",
    BankStatement: "BANK_STATEMENT",
    Other: "OTHER",
};
